import React from "react";
import { Button, Row, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";

import * as Common from "../commons/common";
import * as Utils from "../utils/utils";
import * as TypeDTO from "../commons/typeDTO";

import styles from "./PageHeader.module.css";
import settingsIcon from "../assets/images/header/settings.svg";
import rutaLogo from "../assets/images/ruta40-logo.svg";
import infoIcon from "../assets/images/header/infoIcon.svg";
import backArrow from "../assets/images/backArrow.svg";

export type TypeHeader = {
    leftType?: string;
    title?: string;
    rightType?: string;
    subRightType?: string;
};

function PageHeader({ myCar, headerType }: { myCar?: TypeDTO.CarDto; headerType?: TypeHeader }) {
    const navigate = useNavigate();

    const onRightBtnClick = () => {
        switch (headerType?.rightType) {
            case "setting":
                navigate(Common.PAGE_SETTINGS);
                break;
            case "info":
                Utils.triggerEvent(Common.EVENT_HEADER_INFO);
                break;
            default:
                break;
        }
    };

    const handleBackClick = () => {
        navigate(-1);
    };

    const getRightIcon = () => {
        switch (headerType?.rightType) {
            case "setting":
                return settingsIcon;
            case "info":
                return infoIcon;
            default:
                return infoIcon;
        }
    };

    return (
        <Row className={styles.wrapper} justify={headerType?.leftType === "logo" ? "space-between" : "center"}>
            {headerType?.leftType === "logo" ? (
                <div className={styles.logo}>
                    <img className={styles.logoImg} src={rutaLogo} height={34} />
                </div>
            ) : headerType?.leftType === "none" ? (
                ""
            ) : (
                <div className={styles.back}>
                    <Button type="text" onClick={handleBackClick}>
                        <img src={backArrow} alt="backarrow for going back in history" />
                    </Button>
                </div>
            )}

            <p className={styles.headerText}>{headerType?.title}</p>

            {headerType?.subRightType === "mainPowerPopup" && (
                <div className={styles.subRightButton}>
                    <Tooltip
                        overlayClassName={styles.mainPowerTooltip}
                        defaultOpen={true}
                        trigger="click"
                        placement="bottomRight"
                        title={
                            myCar?.hasSwingDoor ? (
                                <>
                                    <p>메인전원 켜진 상태</p>
                                    <p style={{ marginBottom: 8 }}>- 차량도어 잠금/해제 가능</p>
                                    <p>KEY ON(2단계) 또는 시동 상태 </p>
                                    <p>- 배터리/주행 정보</p>
                                    <p>- 스윙도어 잠금/해제 가능</p>
                                </>
                            ) : (
                                <>
                                    <p>메인전원 켜진 상태</p>
                                    <p>- 차량도어 잠금/해제 가능</p>
                                </>
                            )
                        }
                    >
                        <Button type="text">
                            <img
                                width={headerType?.rightType === "setting" ? 24 : 22}
                                height={headerType?.rightType === "setting" ? 24 : 22}
                                src={infoIcon}
                                alt="rightside icon"
                            />
                        </Button>
                    </Tooltip>
                </div>
            )}

            {headerType?.rightType && (
                <div className={styles.rightButton}>
                    <Button type="text" onClick={onRightBtnClick}>
                        <img
                            width={headerType?.rightType === "setting" ? 24 : 22}
                            height={headerType?.rightType === "setting" ? 24 : 22}
                            src={getRightIcon()}
                            alt="rightside icon"
                        />
                    </Button>
                </div>
            )}
        </Row>
    );
}

export default PageHeader;
